import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import axios from "axios";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";

axios.defaults.withCredentials = true;

const readCookie = (name) => {
  if (typeof document === "undefined") return "";
  const found = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));
  if (!found) return "";
  return decodeURIComponent(found.split("=").slice(1).join("="));
};

if (!axios.__csrfInterceptorInstalled) {
  axios.interceptors.request.use((config) => {
    const method = (config.method || "get").toLowerCase();
    if (["post", "put", "patch", "delete"].includes(method)) {
      const csrfToken = readCookie("saas_dco_csrf");
      if (csrfToken) {
        config.headers = config.headers || {};
        config.headers["X-CSRF-Token"] = csrfToken;
      }
    }
    return config;
  });
  axios.__csrfInterceptorInstalled = true;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
